export default function({ store, redirect, route }) {
  if (!store.state.auth.token) {
    const previousPath = route.path ? `?redirect=${route.path}` : '';
    return redirect(`/signin${previousPath}`);
  }
}
